// Styles librairies
import '../../scss/components/pajination'

// Scripts librairies
import '../../js/libs/paginate/jquery.paginate.min.js'

// jquery pajinate
const _c = $('div.pajinate')
_c.each(function () {
  const _t = $(this)
  const _perPage = _t.attr('data-pajinante-items-per-page') || 5
  const _numLinks = _t.attr('data-pajinante-num-links') || 5
  _t.pajinate({
    items_per_page: parseInt(_perPage),
    num_page_links_to_display: parseInt(_numLinks),
    item_container_id: _t.attr('data-pajinate-container') || '.pajinate-container',
    nav_panel_id: '.pajinate-nav ul',
    show_first_last: false,
    wrap_around: false,
    abort_on_small_lists: true,
    start_page: 0,
    nav_label_prev: '<i class="icon-prev"></i>',
    nav_label_next: '<i class="icon-next"></i>',
    nav_label_first: '<small>début</small>',
    nav_label_last: '<small>fin</small>'
  })
})
